import { DEFAULT_STATUS, StatusIcon } from "@/runs/status"

export const StatusCell = ({ value }: { value: string }) => {
  return <StatusIcon status={value || DEFAULT_STATUS} size={20} />
}
